module.exports = "/images/bg_92b88e.png";